module.exports = __webpack_public_path__ + "static/media/03_04.d7b4ba9a.png";